import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const schedule = {

  namespaced: true,

  state: {
    size: {
      label: 40,
      horizontal: {
        top: 43,
        left: 70,
        room: 260,
        hour: 2,
      },
      vertical: {
        top: 28,
        left: 220,
        room: 90,
        hour: 2,
      },
    },
    sizes: {
      horizontal: {
        room: [
          { size: 80, label: 'XS' },
          { size: 140, label: 'S' },
          { size: 200, label: 'M' },
          { size: 260, label: 'L' },
          { size: 320, label: 'XL' },
        ],
        hour: [
          { size: .5, label: 'S' },
          { size: 1, label: 'M' },
          { size: 2, label: 'L' }
        ],
      },
      vertical: {
        room: [
          { size: 30, label: 'XS' },
          { size: 60, label: 'S' },
          { size: 90, label: 'M' },
          { size: 120, label: 'L' },
          { size: 150, label: 'XL' },
        ],
        hour: [
          { size: 1, label: 'S' },
          { size: 2, label: 'M' },
          { size: 4, label: 'L' }
        ],
      },
    },
    keys: {
      horizontal: {
        room: {
          increase: 39,
          decrease: 37,
        },
        hour: {
          increase: 38,
          decrease: 40,
        },
      },
      vertical: {
        room: {
          increase: 40,
          decrease: 38,
        },
        hour: {
          increase: 37,
          decrease: 39,
        },
      },
    },
    width: 0,
    height: 0,
  },

  getters: {
    size: state => state.size,
    sizes: state => state.sizes,
    keys: state => state.keys,
    width: state => state.width,
    height: state => state.height,
  },

  mutations: {
    setWidth(state, width) { state.width = width },
    setHeight(state, height) { state.height = height },
  },

  actions: {

  },

}
